export const getMessageError = (message = '',) => message.replace('GraphQL error: ', '',)
